import { useState, useEffect } from "react";

interface CountryDetectionResult {
  country: string | null;
  isLoading: boolean;
  isIndian: boolean;
}

export function useCountryDetection(): CountryDetectionResult {
  const [country, setCountry] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const cached = sessionStorage.getItem("detected_country");
    if (cached) {
      setCountry(cached);
      setIsLoading(false);
      return;
    }

    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        const detectedCountry = data.country_name || null;
        setCountry(detectedCountry);
        if (detectedCountry) {
          sessionStorage.setItem("detected_country", detectedCountry);
        }
      })
      .catch(() => {
        setCountry(null);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return {
    country,
    isLoading,
    isIndian: country?.toLowerCase() === "india",
  };
}
